jQuery(document).ready(function() {
  setTimeout(function(){
 var maxHeight = 0;
  jQuery('.prod_case .home-builder > div > div .d-flex').each(function() {
    var height = jQuery(this).height();
       if (height > maxHeight) {
      maxHeight = height;
   }
  });
  maxHeight += 15;
  jQuery('.prod_case .home-builder > div > div .d-flex').height(maxHeight);
    },400);
});


jQuery(document).ready(function() {
  if (jQuery('.main-banner').length > 0) {
    jQuery('.main-banner').addClass('border-radius-0');
  }
  if (jQuery('.middle-banner').length > 0) {
    jQuery('.middle-banner').addClass('border-radius-0');
  }
  if (jQuery('.middle-2-banner').length > 0) {
    jQuery('.middle-2-banner').addClass('border-radius-0');
  }
  if (jQuery('.bottom-banner').length > 0) {
    jQuery('.bottom-banner').addClass('border-radius-0');
  }
});

// jQuery(document).ready(function() {
//   setTimeout(function(){
//  var maxHeight = 0;
//   jQuery('.cate-mid-list .d-flex.flex-column.mt-15').each(function() {
//     var height = jQuery(this).height();
//        if (height > maxHeight) {
//       maxHeight = height;
//    }
//   });
//   jQuery('.cate-mid-list .d-flex.flex-column.mt-15').height(maxHeight);
//     },400);
// });
window.addEventListener("scroll", function() {
  // Check if the element with class "active" exists among the specified elements
  var isActive = jQuery(".menu__panel div.menu__item.position-lg-relative").hasClass("active");

  // Check if the ".header__content--sticky" class is toggled on any of the specified elements
  var isHeaderSticky = jQuery(".Create-Your-Own, .Cases, .Skins").find(".header__content--sticky").length > 0;

  // Get the current scroll position
  var scrollPosition = window.scrollY;

  if (isActive && scrollPosition === 0 && isHeaderSticky) {
    var headerHeight = jQuery(".header--sticky-type-slim").outerHeight();
    var windowWidth = jQuery(window).width();

    if (windowWidth >= 1025) {
      jQuery(".Create-Your-Own .menu__list.menu__level-03.position-lg-absolute.p-lg-15, .Cases .menu__list.menu__level-03.position-lg-absolute.p-lg-15, .Skins .menu__list.menu__level-03.position-lg-absolute.p-lg-15").css("top", headerHeight + "px");
    }
  }
});

